import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

/**
 * One task of a queue — a receipt, an order — as a card that is a link, with
 * room for a thumb.
 *
 * @param {object} props
 * @param {string} props.to
 * @param {string} props.title
 * @param {React.ReactNode} [props.subtitle]
 * @param {React.ReactNode} [props.aside] - A badge or a count, on the right.
 * @param {React.ReactNode} [props.children] - e.g. a progress bar.
 * @param {string} props.testId
 * @param {object} [props.data] - Extra `data-*` attributes.
 */
export const TaskCard = ({ to, title, subtitle, aside, children, testId, data = {} }) => (
  <Link
    to={to}
    data-testid={testId}
    {...data}
    className="block rounded-2xl border border-border bg-white p-4 shadow-sm transition-colors hover:border-ninja-green active:bg-ninja-gray dark:bg-[#1a1a1a] dark:active:bg-[#222]"
  >
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        {/* Wraps instead of cutting: «#123456 - ORD-…» does not fit beside a badge on a phone. */}
        <p data-testid="task-title" className="break-words text-base font-bold text-ninja-dark dark:text-white">
          {title}
        </p>
        {subtitle && <p className="mt-0.5 text-sm text-text-secondary">{subtitle}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {aside}
        <ChevronLeft size={20} className="rotate-180 text-text-muted" />
      </div>
    </div>
    {children && <div className="mt-3">{children}</div>}
  </Link>
);
